import React, { useState } from 'react';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReCAPTCHA from 'react-google-recaptcha';
import * as auth from '../_redux/authRedux';
import { requestPassword } from '../_redux/authCrud';

const initialValues = {
  email: '',
};

function ForgotPassword(props) {
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const [captcha, setCaptcha] = useState('');
  const [loading, setLoading] = useState(false);
  const emailLabel = intl.formatMessage({ id: 'AUTH.LOGIN.EMAIL' });
  const emailFormatError = intl.formatMessage({
    id: 'GENERAL.VALIDATION.INVALID',
  });
  const emailMinLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MIN_LENGTH' })
    .replace('#value#', '7');
  const emailMaxLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MAX_LENGTH' })
    .replace('#value#', '50');

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(emailFormatError)
      .min(7, emailMinLengthError)
      .max(50, emailMaxLengthError)
      .required(
        intl.formatMessage({
          id: 'GENERAL.VALIDATION.REQUIRED',
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid';
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid';
    }

    return '';
  };

  const onCaptchaChange = (value) => {
    console.log('Captcha value:', value);
    setCaptcha(value);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,

    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      console.log('Forgot password request', values.email, captcha);
      requestPassword(values.email, captcha)
        /* .then(() => setIsRequested(true)) */
        .then((response) => {
          console.log('Forgot password response', response.data);
          switch (response.data.type) {
            case 'SUCCESS':
            case 'SUCCESS_WITH_WARNING':
            case 'SUCCESS_WITH_INFO':
              setIsRequested(false);
              setSubmitting(false);
              disableLoading();
              setStatus({ type: 'success', msg: response.data.data });
              break;
            default:
              console.log('Login error', response.data.msg);
              setIsRequested(false);
              setSubmitting(false);
              disableLoading();
              setStatus({ type: 'error', msg: response.data.msg.desc });
              setCaptcha('');
          }
        })
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          disableLoading();
          setStatus({
            type: 'error',
            msg: intl.formatMessage(
              { id: 'AUTH.VALIDATION.NOT_FOUND' },
              { name: values.email }
            ),
          });
          setCaptcha('');
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to='/auth' />}
      {!isRequested && (
        <div className='login-form login-forgot' style={{ display: 'block' }}>
          <div className='text-center mb-10 mb-lg-20'>
            <h3 className='font-size-h1'>
              <FormattedMessage id='AUTH.FORGOT.TITLE' />
            </h3>
            <div className='text-muted font-weight-bold'>
              <FormattedMessage id='AUTH.FORGOT.DESC' />
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className='form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp'
          >
            {formik.status && formik.status.type === 'error' && (
              <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                <div className='alert-text font-weight-bold'>
                  {formik.status.msg}
                </div>
              </div>
            )}

            {formik.status && formik.status.type === 'success' && (
              <div className='mb-10 alert alert-custom alert-light-success alert-dismissible'>
                <div className='alert-text font-weight-bold'>
                  {formik.status.msg}
                </div>
              </div>
            )}
            <div className='form-group fv-plugins-icon-container'>
              <input
                placeholder={emailLabel}
                type='email'
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  'email'
                )}`}
                name='email'
                {...formik.getFieldProps('email')}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.email}</div>
                </div>
              ) : null}
            </div>
            <div className='form-group d-flex flex-wrap flex-center'>
              <ReCAPTCHA
                id='recaptchaForgot'
                sitekey='6LelSq0eAAAAAHnwctgzPHi4o_r-ye7nuYKZn9wz'
                onChange={onCaptchaChange}
              />
            </div>
            <div className='form-group d-flex flex-wrap flex-center'>
              <button
                id='kt_login_forgot_submit'
                type='submit'
                className='btn btn-info font-weight-bold px-9 py-4 my-3 mx-4'
                disabled={formik.isSubmitting}
              >
                <span>
                  <FormattedMessage id='AUTH.FORGOT.SUBMIT' />
                </span>
                {loading && (
                  <span className='ml-3 spinner spinner-white'></span>
                )}
              </button>
              <Link to='/auth'>
                <button
                  type='button'
                  id='kt_login_forgot_cancel'
                  className='btn btn-light-info font-weight-bold px-9 py-4 my-3 mx-4'
                >
                  <FormattedMessage id='AUTH.GENERAL.CANCEL' />
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
